module.exports = __webpack_public_path__ + "static/media/image 1.652af5f0.jpg";